import DetailingSection from "./DetailingSection";
export default DetailingSection;